import { createNamedContext } from '@/utils';

type TableContextValue = {
  EmptyComponent: React.ComponentType;
  empty:          boolean;
  loading:        boolean;
  pageSize:       number;
};

export const TableContext = createNamedContext<TableContextValue>(undefined, 'Table.Context');